var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGitlabinline = function SvgGitlabinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m61.478 35.904-3.316-10.167L51.6 5.573a1.133 1.133 0 0 0-1.075-.772 1.137 1.137 0 0 0-1.076.772L42.89 25.725H21.086L14.524 5.573a1.133 1.133 0 0 0-1.076-.772 1.137 1.137 0 0 0-1.076.772l-6.55 20.152-3.317 10.179a2.25 2.25 0 0 0 .817 2.517L31.986 59.2l28.665-20.78a2.257 2.257 0 0 0 .827-2.517Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.014 59.181 42.91 25.724H21.113l10.9 33.459ZM32.012 59.184l-10.9-33.46H5.855l26.157 33.46ZM5.819 25.735 2.5 35.901a2.25 2.25 0 0 0 .817 2.517L31.983 59.2 5.819 25.735Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.824 25.735H21.1L14.526 5.583a1.133 1.133 0 0 0-1.076-.772 1.137 1.137 0 0 0-1.076.772l-6.55 20.152ZM32.004 59.184 42.9 25.724h15.274l-26.171 33.46Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m58.168 25.735 3.32 10.166a2.25 2.25 0 0 1-.818 2.517L32.004 59.181l26.164-33.446ZM58.168 25.735H42.891l6.562-20.152a1.131 1.131 0 0 1 1.075-.773 1.136 1.136 0 0 1 1.076.773l6.562 20.152h.002Z",
    fill: "currentColor"
  })));
};

export default SvgGitlabinline;